<template>
  <div class="px-5 md:px-8">
    <div class="max-w-7xl mx-auto py-10">
      <div class="flex items-center justify-center lg:hidden">
        <div class="flex-grow border-t-2 border-black"></div>
        <h2 class="text-center text-[21px] text-[#121575] uppercase mb-4">
          Make your dreams<br />
          a reality with us!
        </h2>
        <div class="flex-grow border-t-2 border-black"></div>
      </div>
      <div
        class="flex flex-col-reverse lg:flex-row lg:justify-between items-center"
      >
        <div class="">
          <h2
            class="hidden lg:block text-start text-2xl md:text-3xl text-[#121575] w-max"
          >
            Make your dreams<br />
            a reality with us!
          </h2>
          <div class="pt-2 hidden lg:block">
            <img src="@/assets/LPnew/images/line.png" alt="linesImage" />
          </div>
          <div class="text-start pt-4 font-bold text-xl text-[#121575]">
            Degree from JAIN Online is:
          </div>
          <div class="flex mt-4 items-center gap-2">
            <div class="lg:w-[50px] h-[38px]">
              <img
                src="@/assets/LPnew/images/shapes.svg"
                alt="shapes"
                class=" "
              />
            </div>
            <div class="text-black font-medium text-left w-[281px] lg:w-full">
              Equivalent to JAIN (Deemed-to-be University) on campus degree
            </div>
          </div>
          <div class="flex mt-4 items-center gap-2">
            <div class="lg:w-[50px] h-[38px]">
              <img
                src="@/assets/LPnew/images/shapes.svg"
                alt="shapes"
                class=""
              />
            </div>
            <div
              class="text-black font-medium text-left w-[281px] mt-[16px] lg:mt-0 lg:w-full"
            >
              Candidates who are in the final semester of the Bachelor's program
              are also eligible to apply
            </div>
          </div>
        </div>
        <div
          class="w-full md:w-[70%] lg:w-[40%] border-[1rem] border-[#121575]"
        >
          <img
            src="@/assets/LPnew/images/degree-certificate.webp"
            alt="certificate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CertificateView",
};
</script>

<style scoped></style>
